import { SET_CONFIGURATION } from './types';

export const setConfiguration = (
  configuration: any
): {
  type: string;
  configuration: any;
} => ({
  type: SET_CONFIGURATION,
  configuration,
});
